import axios from "axios";


export const getArticles = async (data) => {
    const response = await axios.get("api/articles/internal", data);
    const result = response.data;
    return result;
}

